import React, { FC, Suspense } from 'react';
import { BrowserRouter, Link, Route, Switch, useLocation } from 'react-router-dom';
import PrivateRoutes from './routes/private.routes';
import PublicRoutes from './routes/public.routes';
import AppLayout from './components/AppLayout';
import ActivityNotificationHost from './features/activityNotifications/ActivityNotificationHost';
import ProjectTitleManager from './components/ProjectTitleManager';
import { getStoredAccessToken, shouldMountAuthenticatedGlobalHosts } from './helpers/authSession';
import { Button, Loader } from './style';
import {
	MultiViewHost,
	MultiViewProvider,
	useMultiView,
} from './features/multiView/MultiViewContext';
import { UndoActionProvider } from './components/UndoAction';

const AuthenticatedGlobalHosts: FC = () => {
	const { pathname } = useLocation();
	const { isOpen } = useMultiView();
	return !isOpen && shouldMountAuthenticatedGlobalHosts(pathname) ? (
		<ActivityNotificationHost />
	) : null;
};

const AppRoute: FC = () => (
	<BrowserRouter>
		<UndoActionProvider>
			<MultiViewProvider>
				<ProjectTitleManager />
				<AuthenticatedGlobalHosts />
				<MultiViewHost>
					<Switch>
						{PublicRoutes.map((route, index) => {
							const { Component } = route;
							return (
								<Route key={index} {...route}>
									<Suspense fallback={<Loader />}>
										<Component />
									</Suspense>
								</Route>
							);
						})}
						;
						{getStoredAccessToken() &&
							PrivateRoutes.map((route, index) => {
								const { Component } = route;
								return (
									<Route key={index} {...route}>
										<AppLayout {...route}>
											<Suspense fallback={<Loader />}>
												<Component />
											</Suspense>
										</AppLayout>
									</Route>
								);
							})}
						;
						<Route>
							<Suspense fallback={<Loader />}>
								<div
									style={{
										position: 'absolute',
										top: '50%',
										left: '50%',
										marginRight: '-50%',
										transform: 'translate(-50%, -50%)',
									}}
								>
									<h1 style={{ fontSize: '50px' }}>404</h1>
									<h1 style={{ fontSize: '50px' }}>Page not found!</h1>
									{(localStorage.getItem('USER_ROLE') === 'U' ||
										localStorage.getItem('USER_ROLE') === 'OA' ||
										localStorage.getItem('USER_ROLE') === 'A') && (
										<div style={{ padding: '15%' }}>
											<Link to="/home">
												<Button btnPrimary>Home</Button>
											</Link>
										</div>
									)}
									{localStorage.getItem('USER_ROLE') === 'PO' && (
										<div style={{ padding: '15%' }}>
											<Link to="/dashboard">
												<Button btnPrimary>Dashboard</Button>
											</Link>
										</div>
									)}
									{!localStorage.getItem('USER_ROLE') && (
										<div style={{ padding: '15%' }}>
											<Link to="/">
												<Button btnPrimary>Login</Button>
											</Link>
										</div>
									)}
								</div>
							</Suspense>
						</Route>
					</Switch>
				</MultiViewHost>
			</MultiViewProvider>
		</UndoActionProvider>
	</BrowserRouter>
);

export default AppRoute;
